module.exports = __webpack_public_path__ + "365b7e9246a837166c5f2510d61bf5ad.svg";